(function() {
  function initMuteButtons() {
    var buttons = document.querySelectorAll('.hero-mute-btn');
    if (!buttons.length) return;

    buttons.forEach(function(btn) {
      var section = btn.closest('.video-parent-section');
      if (!section) return;

      var isMuted = true;

      function updateBtn() {
        btn.querySelector('.hero-mute-btn__icon--muted').style.display = isMuted ? '' : 'none';
        btn.querySelector('.hero-mute-btn__icon--sound').style.display = isMuted ? 'none' : '';
      }

      btn.addEventListener('click', function() {
        // YouTube (iframe)
        var iframe = section.querySelector('iframe[src*="youtube"]');
        if (iframe && iframe.contentWindow) {
          isMuted = !isMuted;
          try {
            iframe.contentWindow.postMessage(
              JSON.stringify({ event: 'command', func: isMuted ? 'mute' : 'unMute', args: [] }), '*'
            );
          } catch(e) {}
          updateBtn();
          return;
        }

        // MP4 (video nativo)
        var video = section.querySelector('video');
        if (video) {
          isMuted = !isMuted;
          video.muted = isMuted;
          updateBtn();
          return;
        }
      });

      updateBtn();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMuteButtons);
  } else {
    initMuteButtons();
  }
})();
// Fuerza autoplay en iOS para videos MP4
var videos = document.querySelectorAll('.video-parent-section video');
videos.forEach(function(video) {
  video.muted = true;
  video.playsInline = true;
  video.autoplay = true;
  var playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise.catch(function() {
      // Si falla, intenta al primer scroll o tap
      document.addEventListener('touchstart', function() {
        video.play();
      }, { once: true });
    });
  }
});
